module.exports = "https://static.wanderu.com/static/media/sliders.4af81418.svg";